module.exports = __webpack_public_path__ + "img/vector-1@3x.4b32d3a0.png";